import React from 'react';
import { Route } from 'react-router-dom';
import LoadableWithLoading from '@ncigdc/components/LoadableWithLoading';

export default (
  <Route
    path="/programs/:id"
    component={LoadableWithLoading({ loader: () => import('./ProgramRoute') })}
  />
);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/routes/ProgramRoute/index.js